<template>
  <div>
    <el-carousel trigger="click" height="220px" :interval="10000">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <img :src="item.url" autoplay loop style="width: 100%" controls />
        <p class="small">{{ item.name }}</p>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "交通",
          url: require("../assets/交通.gif"),
        },
        {
          name: "教育",
          url: require("../assets/教育.gif"),
        },
        {
          name: "医疗",
          url: require("../assets/医疗.gif"),
        },
        {
          name: "配套",
          url: require("../assets/配套.gif"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  z-index: 1000;
}
</style>
